import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { PlanLimits } from '@/types/api';

const FALLBACK_LIMITS: PlanLimits = {
  maxMt5Accounts: 1,
  maxBotsPerUser: 2,
};

export function usePlanLimits(): PlanLimits {
  const { data } = useQuery<{ limits: PlanLimits }>({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const res = await api.get('/auth/me');
      return res.data;
    },
    staleTime: 5 * 60_000, // 5 min — limits rarely change
  });

  return data?.limits ?? FALLBACK_LIMITS;
}
